import { defaultTheme } from 'react-admin';

const BRAND = '#AE256D';

const theme = {
  ...defaultTheme,
  sidebar: {
    width: 232,
    closedWidth: 48,
  },
  palette: {
    ...defaultTheme.palette,
    primary: {
      ...defaultTheme.palette?.primary,
      main: BRAND,
      contrastText: '#fff',
    },
    secondary: {
      ...defaultTheme.palette?.secondary,
      main: BRAND,
      contrastText: '#fff',
    },
  },
  components: {
    ...defaultTheme.components,
    RaLayout: {
      styleOverrides: {
        root: {
          height: '100vh',
          overflow: 'hidden',
          '& .RaLayout-appFrame': {
            marginTop: 0,
          },
        },
        appFrame: {
          marginTop: 0,
        },
        content: {
          minWidth: 0,
          overflowX: 'auto',
          overflowY: 'auto',
        },
        contentWithSidebar: {
          minWidth: 0,
          overflow: 'hidden',
        },
      },
    },
    RaSidebar: {
      styleOverrides: {
        root: {
          zIndex: 1201,
        },
        fixed: {
          zIndex: 1201,
        },
      },
    },
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          '&.RaMenuItemLink-active': {
            borderLeft: `3px solid ${BRAND}`,
          },
        },
      },
    },
    RaDatagrid: {
      styleOverrides: {
        root: {
          width: '100%',
          overflowX: 'auto',
        },
        tableWrapper: {
          overflowX: 'auto',
          width: '100%',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          position: 'sticky',
          top: 0,
          zIndex: 1202,
          backgroundColor: `${BRAND} !important`,
          backgroundImage: 'none',
          color: '#fff',
          boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
        },
        colorSecondary: {
          backgroundColor: `${BRAND} !important`,
          color: '#fff',
        },
        colorPrimary: {
          backgroundColor: `${BRAND} !important`,
          color: '#fff',
        },
      },
    },
    // Keep i18n Turkish casing (i→İ); default MUI uppercase breaks dotted İ with lang/en.
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
};

export default theme;
